var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDartLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 40,
    viewBox: "0 0 146 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.283203 14.7289V0H5.10356C7.04955 0 8.55814 0.499888 9.60255 1.49074C10.6559 2.49052 11.1826 3.99018 11.1826 5.98973V8.74805C11.1826 10.7565 10.6559 12.2473 9.60255 13.2381C8.54921 14.229 7.04955 14.7199 5.10356 14.7199H0.283203V14.7289ZM2.55948 12.6668H5.13033C6.40684 12.6668 7.35305 12.3455 7.96899 11.7027C8.58492 11.06 8.89735 10.096 8.89735 8.81946V5.91832C8.89735 4.62397 8.58492 3.66882 7.96899 3.03504C7.35305 2.40125 6.40684 2.08882 5.13033 2.08882H2.55948V12.6757V12.6668Z",
    fill: "url(#paint0_linear_2127_1476)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0121 2.94577C14.5926 2.94577 14.2355 2.81187 13.9499 2.53515C13.6642 2.25842 13.5214 1.91029 13.5214 1.47289C13.5214 1.03548 13.6642 0.687346 13.9499 0.410623C14.2355 0.133899 14.5926 0 15.0121 0C15.4317 0 15.8066 0.133899 16.0833 0.410623C16.36 0.687346 16.5029 1.03548 16.5029 1.47289C16.5029 1.91029 16.36 2.25842 16.0833 2.53515C15.8066 2.81187 15.4406 2.94577 15.0121 2.94577ZM13.9142 14.7289V4.35617H16.0833V14.7289H13.9142Z",
    fill: "url(#paint1_linear_2127_1476)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7969 9.28369C18.7969 8.18572 19.0201 7.25736 19.4575 6.48967C19.8949 5.72199 20.484 5.12391 21.216 4.70436C21.948 4.28481 22.7425 4.07057 23.6173 4.07057C24.626 4.07057 25.4026 4.25803 25.9382 4.64187C26.4827 5.01679 26.8755 5.42741 27.1254 5.86481H27.4646V4.37408H29.5713V16.8713C29.5713 17.5051 29.3838 18.005 29.0178 18.3888C28.6429 18.7637 28.1341 18.9601 27.4914 18.9601H20.5108V17.0677H26.8219C27.2325 17.0677 27.4289 16.8534 27.4289 16.4339V13.131H27.0897C26.938 13.381 26.7148 13.6399 26.4381 13.9077C26.1613 14.1755 25.7864 14.3897 25.3312 14.5593C24.8759 14.7289 24.3046 14.8092 23.6173 14.8092C22.7514 14.8092 21.948 14.6039 21.2071 14.1844C20.4662 13.7738 19.886 13.1757 19.4486 12.3991C19.0112 11.6225 18.7969 10.6941 18.7969 9.61398V9.28369ZM24.2064 12.899C25.1437 12.899 25.9203 12.6044 26.5273 12.0063C27.1343 11.4082 27.4468 10.587 27.4468 9.53364V9.34618C27.4468 8.26606 27.1433 7.43589 26.5452 6.85566C25.9382 6.27544 25.1616 5.98086 24.2064 5.98086C23.2513 5.98086 22.5104 6.27544 21.9034 6.85566C21.2964 7.43589 20.9839 8.26606 20.9839 9.34618V9.53364C20.9839 10.587 21.2874 11.4082 21.9034 12.0063C22.5104 12.6044 23.2781 12.899 24.2064 12.899Z",
    fill: "url(#paint2_linear_2127_1476)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8649 2.94577C33.4454 2.94577 33.0883 2.81187 32.8027 2.53515C32.517 2.25842 32.3742 1.91029 32.3742 1.47289C32.3742 1.03548 32.517 0.687346 32.8027 0.410623C33.0883 0.133899 33.4454 0 33.8649 0C34.2845 0 34.6594 0.133899 34.9361 0.410623C35.2129 0.687346 35.3557 1.03548 35.3557 1.47289C35.3557 1.91029 35.2129 2.25842 34.9361 2.53515C34.6594 2.81187 34.2934 2.94577 33.8649 2.94577ZM32.767 14.7289V4.35617H34.9361V14.7289H32.767Z",
    fill: "url(#paint3_linear_2127_1476)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0418 14.7289C41.408 14.7289 40.9081 14.5414 40.5421 14.1576C40.1672 13.7827 39.9886 13.2739 39.9886 12.6401V6.17723H37.1232V4.34728H39.9886V0.928399H42.1578V4.3562H45.2464V6.18615H42.1578V12.2652C42.1578 12.6847 42.3542 12.8989 42.747 12.8989H44.9161V14.7289H42.0418Z",
    fill: "url(#paint4_linear_2127_1476)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9861 15.0235C50.2452 15.0235 49.5757 14.8985 48.9955 14.6486C48.4153 14.3986 47.9511 14.0237 47.6029 13.5327C47.2548 13.0418 47.0852 12.4437 47.0852 11.7474C47.0852 11.0512 47.2548 10.4441 47.6029 9.97104C47.9421 9.49793 48.4153 9.14979 49.0133 8.90878C49.6114 8.66776 50.2898 8.55171 51.0397 8.55171H54.1997V7.88222C54.1997 7.27521 54.0211 6.79318 53.6552 6.42719C53.2892 6.0612 52.7268 5.88267 51.968 5.88267C51.2093 5.88267 50.6558 6.0612 50.2631 6.40933C49.8703 6.75747 49.6114 7.21273 49.4864 7.7751L47.469 7.12346C47.6386 6.56109 47.9064 6.05227 48.2814 5.59702C48.6563 5.14176 49.1472 4.77577 49.7632 4.49012C50.3791 4.2134 51.12 4.07057 51.9948 4.07057C53.3427 4.07057 54.3961 4.40978 55.1727 5.09713C55.9404 5.78447 56.3331 6.75747 56.3331 8.02505V12.292C56.3331 12.7115 56.5295 12.9257 56.9223 12.9257H57.806V14.7378H56.1903C55.6993 14.7378 55.2976 14.6129 54.9941 14.3629C54.6817 14.113 54.53 13.7648 54.53 13.3364V13.2739H54.2175C54.1015 13.4881 53.9408 13.7291 53.7087 14.0148C53.4855 14.2915 53.1553 14.5414 52.7179 14.7378C52.2805 14.9431 51.7092 15.0413 50.995 15.0413L50.9861 15.0235ZM51.2985 13.2382C52.1644 13.2382 52.8696 12.9882 53.4052 12.4883C53.9408 11.9884 54.2086 11.31 54.2086 10.4352V10.221H51.1825C50.6112 10.221 50.147 10.346 49.7899 10.587C49.4418 10.8369 49.2633 11.194 49.2633 11.6671C49.2633 12.1402 49.4418 12.524 49.8078 12.8008C50.1738 13.0775 50.6737 13.2203 51.2985 13.2203V13.2382Z",
    fill: "url(#paint5_linear_2127_1476)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9039 14.7289V0H62.073V14.7289H59.9039Z",
    fill: "url(#paint6_linear_2127_1476)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2232 14.7289L73.4365 0H77.4356L81.6222 14.7289H79.2834L78.3193 11.2564H72.5528L71.5887 14.7289H69.2232ZM73.1151 9.14974H77.7391L75.5967 1.4104H75.2575L73.1151 9.14974Z",
    fill: "url(#paint7_linear_2127_1476)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6842 14.7288V4.35612H85.8087V5.90934H86.1479C86.3443 5.48979 86.6924 5.09702 87.2012 4.73103C87.71 4.36504 88.4599 4.18651 89.4507 4.18651C90.2363 4.18651 90.9325 4.36504 91.5396 4.71318C92.1466 5.06132 92.6286 5.56121 92.9857 6.19499C93.3338 6.83771 93.5123 7.60539 93.5123 8.49805V14.7288H91.3432V8.66765C91.3432 7.775 91.12 7.1055 90.6737 6.67703C90.2273 6.24855 89.6114 6.03431 88.8259 6.03431C87.9243 6.03431 87.2102 6.32889 86.6656 6.91805C86.1211 7.5072 85.8533 8.36415 85.8533 9.4889V14.7288H83.6842Z",
    fill: "url(#paint8_linear_2127_1476)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6188 14.7288V4.35612H98.7433V5.90934H99.0825C99.2789 5.48979 99.627 5.09702 100.136 4.73103C100.645 4.36504 101.394 4.18651 102.385 4.18651C103.171 4.18651 103.867 4.36504 104.474 4.71318C105.081 5.06132 105.563 5.56121 105.92 6.19499C106.268 6.83771 106.447 7.60539 106.447 8.49805V14.7288H104.278V8.66765C104.278 7.775 104.055 7.1055 103.608 6.67703C103.162 6.24855 102.546 6.03431 101.76 6.03431C100.859 6.03431 100.145 6.32889 99.6002 6.91805C99.0557 7.5072 98.7879 8.36415 98.7879 9.4889V14.7288H96.6188Z",
    fill: "url(#paint9_linear_2127_1476)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M113.365 14.9163C112.58 14.9163 111.874 14.7378 111.259 14.3896C110.643 14.0415 110.161 13.5416 109.803 12.8989C109.446 12.2562 109.277 11.4796 109.277 10.5869V4.35617H111.446V10.4352C111.446 11.3368 111.669 11.9973 112.115 12.4258C112.562 12.8543 113.187 13.0685 113.99 13.0685C114.874 13.0685 115.588 12.7739 116.124 12.1759C116.659 11.5778 116.936 10.7208 116.936 9.59608V4.35617H119.105V14.7289H116.98V13.1756H116.641C116.445 13.5952 116.097 13.9969 115.588 14.3629C115.079 14.7378 114.338 14.9163 113.356 14.9163H113.365Z",
    fill: "url(#paint10_linear_2127_1476)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M125.523 15.0235C124.782 15.0235 124.113 14.8985 123.532 14.6486C122.952 14.3986 122.488 14.0237 122.14 13.5327C121.792 13.0418 121.622 12.4437 121.622 11.7474C121.622 11.0512 121.792 10.4441 122.14 9.97104C122.479 9.49793 122.952 9.14979 123.55 8.90878C124.148 8.66776 124.827 8.55171 125.577 8.55171H128.737V7.88222C128.737 7.27521 128.558 6.79318 128.192 6.42719C127.826 6.0612 127.264 5.88267 126.505 5.88267C125.746 5.88267 125.193 6.0612 124.8 6.40933C124.407 6.75747 124.148 7.21273 124.023 7.7751L122.006 7.12346C122.176 6.56109 122.443 6.05227 122.818 5.59702C123.193 5.14176 123.684 4.77577 124.3 4.49012C124.916 4.2134 125.657 4.07057 126.532 4.07057C127.88 4.07057 128.933 4.40978 129.71 5.09713C130.477 5.78447 130.87 6.75747 130.87 8.02505V12.292C130.87 12.7115 131.066 12.9257 131.459 12.9257H132.343V14.7378H130.727C130.236 14.7378 129.835 14.6129 129.531 14.3629C129.219 14.113 129.067 13.7648 129.067 13.3364V13.2739H128.754C128.638 13.4881 128.478 13.7291 128.246 14.0148C128.014 14.3004 127.692 14.5414 127.255 14.7378C126.817 14.9431 126.246 15.0413 125.532 15.0413L125.523 15.0235ZM125.835 13.2382C126.701 13.2382 127.407 12.9882 127.942 12.4883C128.478 11.9884 128.746 11.31 128.746 10.4352V10.221H125.719C125.148 10.221 124.684 10.346 124.327 10.587C123.979 10.8369 123.8 11.194 123.8 11.6671C123.8 12.1402 123.979 12.524 124.345 12.8008C124.711 13.0775 125.211 13.2203 125.835 13.2203V13.2382Z",
    fill: "url(#paint11_linear_2127_1476)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M134.45 14.7289V0H136.619V14.7289H134.45Z",
    fill: "url(#paint12_linear_2127_1476)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0.283203 21.0399H6.46932C7.37983 21.0399 8.18322 21.2006 8.8795 21.513C9.57577 21.8254 10.1114 22.2807 10.4952 22.8698C10.8791 23.459 11.0754 24.1642 11.0754 24.9765V25.2086C11.0754 26.137 10.8523 26.8779 10.4149 27.4313C9.97747 27.9848 9.43295 28.3775 8.80809 28.6007V28.9399C9.34368 28.9667 9.77216 29.1452 10.0935 29.4755C10.4149 29.8058 10.5755 30.2789 10.5755 30.8948V35.7777H8.28142V31.2162C8.28142 30.8413 8.18323 30.5378 7.98684 30.3146C7.79046 30.0914 7.47802 29.9754 7.04062 29.9754H2.55948V35.7777H0.283203V21.0399ZM2.55948 27.9044H6.21938C7.0317 27.9044 7.66548 27.6991 8.11181 27.2796C8.55814 26.86 8.78131 26.2976 8.78131 25.5835V25.4139C8.78131 24.6998 8.55814 24.1374 8.12074 23.7179C7.67441 23.3072 7.04062 23.093 6.21938 23.093H2.55948V27.9044Z",
    fill: "url(#paint13_linear_2127_1476)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3951 36.0634C17.3418 36.0634 16.4224 35.8402 15.6368 35.4028C14.8513 34.9565 14.2354 34.3405 13.798 33.5282C13.3606 32.7159 13.1374 31.7875 13.1374 30.7164V30.4664C13.1374 29.3863 13.3516 28.4401 13.789 27.6367C14.2264 26.8333 14.8334 26.2084 15.6101 25.7621C16.3867 25.3158 17.2882 25.1015 18.3148 25.1015C19.3414 25.1015 20.1805 25.3247 20.9303 25.7621C21.6801 26.2084 22.2693 26.8154 22.6888 27.601C23.1084 28.3865 23.3226 29.306 23.3226 30.3593V31.1805H15.3512C15.378 32.091 15.6815 32.8141 16.2706 33.3586C16.8508 33.8942 17.5739 34.1709 18.4487 34.1709C19.261 34.1709 19.877 33.9924 20.2876 33.6264C20.6982 33.2604 21.0196 32.8409 21.2427 32.3678L23.028 33.2961C22.8317 33.6889 22.546 34.0995 22.1711 34.5369C21.7962 34.9743 21.3141 35.3403 20.7071 35.6349C20.1001 35.9295 19.3324 36.0812 18.3951 36.0812V36.0634ZM15.369 29.5202H21.1088C21.0553 28.7346 20.7696 28.1187 20.2697 27.6813C19.7609 27.2439 19.1093 27.0207 18.297 27.0207C17.4846 27.0207 16.8241 27.2439 16.3063 27.6813C15.7975 28.1276 15.4851 28.7346 15.369 29.5202Z",
    fill: "url(#paint14_linear_2127_1476)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9292 39.9732V25.3961H28.0538V26.8868H28.393C28.6608 26.4227 29.0625 26.012 29.607 25.6461C30.1426 25.2801 30.9192 25.1015 31.9279 25.1015C32.7938 25.1015 33.5972 25.3158 34.3113 25.7353C35.0343 26.1549 35.6146 26.7619 36.0609 27.5563C36.5072 28.3508 36.7215 29.306 36.7215 30.4307V30.7431C36.7215 31.8679 36.5072 32.823 36.0698 33.6175C35.6324 34.412 35.0522 35.019 34.3202 35.4385C33.5882 35.8581 32.7938 36.0723 31.919 36.0723C31.2495 36.0723 30.6782 35.992 30.214 35.8224C29.7498 35.6527 29.3749 35.4385 29.0982 35.1796C28.8214 34.9208 28.5894 34.653 28.4287 34.3673H28.0895V39.9821H25.9203L25.9292 39.9732ZM31.2941 34.1709C32.2493 34.1709 33.0259 33.8674 33.6329 33.2694C34.231 32.6623 34.5345 31.8054 34.5345 30.6806V30.4932C34.5345 29.3863 34.2309 28.5293 33.6239 27.9223C33.0169 27.3153 32.2403 27.0207 31.303 27.0207C30.3657 27.0207 29.607 27.3242 29 27.9223C28.393 28.5204 28.0805 29.3774 28.0805 30.4932V30.6806C28.0805 31.8054 28.384 32.6623 29 33.2694C29.6159 33.8764 30.3747 34.1709 31.303 34.1709H31.2941Z",
    fill: "url(#paint15_linear_2127_1476)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2734 36.0634C43.2379 36.0634 42.3095 35.8491 41.5062 35.4207C40.7028 34.9922 40.069 34.3763 39.6048 33.5818C39.1406 32.7873 38.9085 31.8322 38.9085 30.7431V30.4307C38.9085 29.3327 39.1406 28.3954 39.6048 27.601C40.069 26.8065 40.7028 26.1906 41.5062 25.7621C42.3095 25.3247 43.2379 25.1105 44.2734 25.1105C45.3089 25.1105 46.2372 25.3247 47.0496 25.7621C47.8619 26.1995 48.5046 26.8065 48.9599 27.601C49.4151 28.3954 49.6561 29.3327 49.6561 30.4307V30.7431C49.6561 31.8411 49.424 32.7873 48.9599 33.5818C48.4957 34.3763 47.8619 34.9922 47.0496 35.4207C46.2372 35.8491 45.3089 36.0634 44.2734 36.0634ZM44.2734 34.1263C45.2285 34.1263 46.0052 33.8228 46.5943 33.2069C47.1835 32.5909 47.487 31.7518 47.487 30.6717V30.4843C47.487 29.4042 47.1924 28.5561 46.6032 27.9491C46.0141 27.3421 45.2375 27.0297 44.2645 27.0297C43.2915 27.0297 42.5595 27.3332 41.9614 27.9491C41.3633 28.5561 41.0688 29.4042 41.0688 30.4843V30.6717C41.0688 31.7518 41.3633 32.5999 41.9614 33.2069C42.5595 33.8139 43.3272 34.1263 44.2645 34.1263H44.2734Z",
    fill: "url(#paint16_linear_2127_1476)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M52.352 35.7688V25.3961H54.4765V26.6191H54.8157C54.9853 26.1817 55.2531 25.8693 55.6281 25.6639C56.003 25.4586 56.4582 25.3604 57.0028 25.3604H58.2435V27.3154H56.9224C56.2172 27.3154 55.6459 27.5117 55.1996 27.8956C54.7533 28.2794 54.5301 28.8775 54.5301 29.672V35.7688H52.352Z",
    fill: "url(#paint17_linear_2127_1476)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M64.385 35.7688C63.7512 35.7688 63.2513 35.5813 62.8853 35.1975C62.5104 34.8226 62.3319 34.3137 62.3319 33.68V27.2171H59.4665V25.3872H62.3319V21.9594H64.5011V25.3872H67.5896V27.2171H64.5011V33.2961C64.5011 33.7157 64.6974 33.9299 65.0902 33.9299H67.2594V35.7598H64.3939L64.385 35.7688Z",
    fill: "url(#paint18_linear_2127_1476)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2228 23.9857C70.8032 23.9857 70.4462 23.8518 70.1605 23.575C69.8748 23.2983 69.732 22.9502 69.732 22.5128C69.732 22.0754 69.8748 21.7272 70.1605 21.4505C70.4462 21.1738 70.8032 21.0399 71.2228 21.0399C71.6423 21.0399 72.0172 21.1738 72.2939 21.4505C72.5707 21.7272 72.7135 22.0754 72.7135 22.5128C72.7135 22.9502 72.5707 23.2983 72.2939 23.575C72.0172 23.8518 71.6602 23.9857 71.2228 23.9857ZM70.1248 35.7687V25.3961H72.2939V35.7687H70.1248Z",
    fill: "url(#paint19_linear_2127_1476)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5164 35.7688V25.3961H77.641V26.9493H77.9802C78.1766 26.5298 78.5247 26.137 79.0335 25.771C79.5423 25.405 80.2921 25.2265 81.283 25.2265C82.0685 25.2265 82.7648 25.405 83.3718 25.7532C83.9788 26.1013 84.4609 26.6012 84.8179 27.235C85.1661 27.8688 85.3446 28.6454 85.3446 29.5381V35.7688H83.1754V29.7077C83.1754 28.815 82.9523 28.1455 82.5059 27.717C82.0596 27.2886 81.4437 27.0743 80.6581 27.0743C79.7566 27.0743 79.0424 27.3689 78.4979 27.958C77.9534 28.5472 77.6856 29.4042 77.6856 30.5289V35.7688H75.5164Z",
    fill: "url(#paint20_linear_2127_1476)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9511 30.3236C87.9511 29.2256 88.1743 28.2973 88.6117 27.5296C89.058 26.7619 89.6382 26.1638 90.3702 25.7443C91.1022 25.3247 91.8966 25.1105 92.7714 25.1105C93.7802 25.1105 94.5568 25.2979 95.0924 25.6818C95.6279 26.0567 96.0296 26.4673 96.2796 26.9047H96.6188V25.414H98.7255V37.9112C98.7255 38.545 98.538 39.0449 98.172 39.4287C97.7971 39.8036 97.2883 40 96.6456 40H89.665V38.1076H95.9761C96.3867 38.1076 96.5831 37.8933 96.5831 37.4738V34.1709H96.2439C96.0921 34.4209 95.869 34.6798 95.5922 34.9476C95.3155 35.2154 94.9406 35.4296 94.4853 35.5992C94.0301 35.7688 93.4588 35.8491 92.7714 35.8491C91.9056 35.8491 91.1022 35.6438 90.3613 35.2243C89.6293 34.8137 89.0401 34.2156 88.6027 33.439C88.1653 32.6624 87.9511 31.734 87.9511 30.6539V30.3236ZM93.3606 33.9389C94.2979 33.9389 95.0745 33.6443 95.6815 33.0462C96.2885 32.4481 96.601 31.6269 96.601 30.5735V30.3861C96.601 29.306 96.2974 28.4758 95.6994 27.8956C95.1013 27.3153 94.3157 27.0208 93.3606 27.0208C92.4054 27.0208 91.6646 27.3153 91.0575 27.8956C90.4505 28.4758 90.1381 29.306 90.1381 30.3861V30.5735C90.1381 31.6269 90.4416 32.4481 91.0575 33.0462C91.6735 33.6443 92.4322 33.9389 93.3606 33.9389Z",
    fill: "url(#paint21_linear_2127_1476)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M110.143 35.7687V23.1019H105.617V21.0399H116.936V23.1019H112.41V35.7687H110.134H110.143Z",
    fill: "url(#paint22_linear_2127_1476)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M121.89 36.0634C120.854 36.0634 119.926 35.8491 119.123 35.4207C118.319 34.9922 117.677 34.3763 117.221 33.5818C116.766 32.7873 116.525 31.8322 116.525 30.7431V30.4307C116.525 29.3327 116.757 28.3954 117.221 27.601C117.686 26.8065 118.319 26.1906 119.123 25.7621C119.926 25.3247 120.854 25.1105 121.89 25.1105C122.925 25.1105 123.854 25.3247 124.666 25.7621C125.478 26.1995 126.121 26.8065 126.576 27.601C127.032 28.3954 127.273 29.3327 127.273 30.4307V30.7431C127.273 31.8411 127.041 32.7873 126.576 33.5818C126.112 34.3763 125.478 34.9922 124.666 35.4207C123.854 35.8491 122.925 36.0634 121.89 36.0634ZM121.89 34.1263C122.845 34.1263 123.622 33.8228 124.211 33.2069C124.8 32.5909 125.104 31.7518 125.104 30.6717V30.4843C125.104 29.4042 124.809 28.5561 124.22 27.9491C123.631 27.3421 122.854 27.0297 121.881 27.0297C120.908 27.0297 120.176 27.3332 119.578 27.9491C118.98 28.5561 118.685 29.4042 118.685 30.4843V30.6717C118.685 31.7518 118.98 32.5999 119.578 33.2069C120.176 33.8139 120.944 34.1263 121.881 34.1263H121.89Z",
    fill: "url(#paint23_linear_2127_1476)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M134.825 36.0634C133.789 36.0634 132.861 35.8491 132.057 35.4207C131.254 34.9922 130.611 34.3763 130.156 33.5818C129.701 32.7873 129.46 31.8322 129.46 30.7431V30.4307C129.46 29.3327 129.692 28.3954 130.156 27.601C130.62 26.8065 131.254 26.1906 132.057 25.7621C132.861 25.3247 133.789 25.1105 134.825 25.1105C135.86 25.1105 136.788 25.3247 137.601 25.7621C138.413 26.1995 139.056 26.8065 139.511 27.601C139.966 28.3954 140.207 29.3327 140.207 30.4307V30.7431C140.207 31.8411 139.975 32.7873 139.511 33.5818C139.047 34.3763 138.413 34.9922 137.601 35.4207C136.788 35.8491 135.86 36.0634 134.825 36.0634ZM134.825 34.1263C135.78 34.1263 136.556 33.8228 137.145 33.2069C137.735 32.5909 138.038 31.7518 138.038 30.6717V30.4843C138.038 29.4042 137.744 28.5561 137.154 27.9491C136.565 27.3421 135.789 27.0297 134.816 27.0297C133.843 27.0297 133.111 27.3332 132.513 27.9491C131.914 28.5561 131.62 29.4042 131.62 30.4843V30.6717C131.62 31.7518 131.914 32.5999 132.513 33.2069C133.111 33.8139 133.878 34.1263 134.816 34.1263H134.825Z",
    fill: "url(#paint24_linear_2127_1476)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M142.903 35.7687V21.0399H145.072V35.7687H142.903Z",
    fill: "url(#paint25_linear_2127_1476)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2127_1476",
    x1: 0.283204,
    y1: 40,
    x2: 148.475,
    y2: -36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644268,
    stopColor: "#4FB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705083,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2127_1476",
    x1: 0.283204,
    y1: 40,
    x2: 148.475,
    y2: -36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644268,
    stopColor: "#4FB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705083,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2127_1476",
    x1: 0.283204,
    y1: 40,
    x2: 148.475,
    y2: -36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644268,
    stopColor: "#4FB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705083,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2127_1476",
    x1: 0.283204,
    y1: 40,
    x2: 148.475,
    y2: -36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644268,
    stopColor: "#4FB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705083,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2127_1476",
    x1: 0.283204,
    y1: 40,
    x2: 148.475,
    y2: -36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644268,
    stopColor: "#4FB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705083,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2127_1476",
    x1: 0.283204,
    y1: 40,
    x2: 148.475,
    y2: -36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644268,
    stopColor: "#4FB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705083,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2127_1476",
    x1: 0.283204,
    y1: 40,
    x2: 148.475,
    y2: -36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644268,
    stopColor: "#4FB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705083,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2127_1476",
    x1: 0.283204,
    y1: 40,
    x2: 148.475,
    y2: -36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644268,
    stopColor: "#4FB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705083,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2127_1476",
    x1: 0.283204,
    y1: 40,
    x2: 148.475,
    y2: -36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644268,
    stopColor: "#4FB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705083,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2127_1476",
    x1: 0.283204,
    y1: 40,
    x2: 148.475,
    y2: -36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644268,
    stopColor: "#4FB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705083,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2127_1476",
    x1: 0.283204,
    y1: 40,
    x2: 148.475,
    y2: -36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644268,
    stopColor: "#4FB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705083,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2127_1476",
    x1: 0.283204,
    y1: 40,
    x2: 148.475,
    y2: -36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644268,
    stopColor: "#4FB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705083,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2127_1476",
    x1: 0.283204,
    y1: 40,
    x2: 148.475,
    y2: -36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644268,
    stopColor: "#4FB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705083,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2127_1476",
    x1: 0.283204,
    y1: 40,
    x2: 148.475,
    y2: -36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644268,
    stopColor: "#4FB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705083,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2127_1476",
    x1: 0.283204,
    y1: 40,
    x2: 148.475,
    y2: -36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644268,
    stopColor: "#4FB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705083,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2127_1476",
    x1: 0.283204,
    y1: 40,
    x2: 148.475,
    y2: -36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644268,
    stopColor: "#4FB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705083,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2127_1476",
    x1: 0.283204,
    y1: 40,
    x2: 148.475,
    y2: -36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644268,
    stopColor: "#4FB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705083,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2127_1476",
    x1: 0.283204,
    y1: 40,
    x2: 148.475,
    y2: -36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644268,
    stopColor: "#4FB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705083,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2127_1476",
    x1: 0.283204,
    y1: 40,
    x2: 148.475,
    y2: -36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644268,
    stopColor: "#4FB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705083,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2127_1476",
    x1: 0.283204,
    y1: 40,
    x2: 148.475,
    y2: -36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644268,
    stopColor: "#4FB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705083,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2127_1476",
    x1: 0.283204,
    y1: 40,
    x2: 148.475,
    y2: -36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644268,
    stopColor: "#4FB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705083,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2127_1476",
    x1: 0.283204,
    y1: 40,
    x2: 148.475,
    y2: -36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644268,
    stopColor: "#4FB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705083,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2127_1476",
    x1: 0.283204,
    y1: 40,
    x2: 148.475,
    y2: -36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644268,
    stopColor: "#4FB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705083,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2127_1476",
    x1: 0.283204,
    y1: 40,
    x2: 148.475,
    y2: -36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644268,
    stopColor: "#4FB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705083,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2127_1476",
    x1: 0.283204,
    y1: 40,
    x2: 148.475,
    y2: -36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644268,
    stopColor: "#4FB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705083,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2127_1476",
    x1: 0.283204,
    y1: 40,
    x2: 148.475,
    y2: -36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644268,
    stopColor: "#4FB49C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.705083,
    stopColor: "#005562"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#387B85"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDartLogo);
export default __webpack_public_path__ + "static/media/DARTLogo.55f46bf086bf79b17c37a9f1839bcfc2.svg";
export { ForwardRef as ReactComponent };